
import React, {useEffect, useState} from 'react'
import Header from '../../../components/header/Header'
import { ReactComponent as Standart } from '../../../assets/icons/portfolio/StandartBriefcase.svg'
import { ReactComponent as Business } from '../../../assets/icons/portfolio/businessBriefcase.svg'
import { ReactComponent as Corporate } from '../../../assets/icons/portfolio/CorporateBriefcase.svg'
import { ReactComponent as CloseIcon } from "../../../assets/icons/portfolio/login-cross.svg";
import { ReactComponent as PRO} from "../../../assets/icons/portfolio/PRO.svg";
import { ReactComponent as ULTRA} from "../../../assets/icons/portfolio/ULTRA.svg";
import { ReactComponent as EXTRA} from "../../../assets/icons/portfolio/EXTRA.svg";
import Button from '../../../components/button/Button'
import axios from 'axios'
import {closeSnackbar, enqueueSnackbar} from "notistack";
import './Portfolio.css'
import {useTranslation} from "react-i18next";
import { useNavigate } from 'react-router-dom'

const Portfolio = () => {

    const {t} = useTranslation();
    const navigate = useNavigate()
    const action = snackbarId => (
        <button className="close-button" onClick={() => { closeSnackbar(snackbarId) }}>
            <CloseIcon/>
            {/* CLOSEICON */}
        </button>
    );

    const [userPortfolioData, setUserPortfolioData] = useState({active: false})
    const [userPortfolioDataReserved, setUserPortfolioDataReserved] = useState([])
    const [portfoliosData, setPortfoliosData] = useState([])
    const [portfoliosDataUpgrade, setPortfoliosDataUpgrade] = useState([])
    const [ILuserPortfolioData, setILUserPortfolioData] = useState(false)
    const [ILPortfolioData, setILPortfolioData] = useState(false)
    const [ILPortfolioDataUP, setILPortfolioDataUP] = useState(false)

    const [switcher, setSwitch] = useState(0)
    const [switcher2, setSwitch2] = useState(0)


    const token = localStorage.getItem("token")
    
    // const token = localStorage.getItem("token")


    const getUserPortfolioData = () => {
        axios.get("https://api-ru.fynex.cc/api/api/user/portfolio", {headers: {"Authorization": `Bearer ${token}`}})
            .then(res => {
                setUserPortfolioData(res.data)
                console.log(res.data, "asdadda1!!!");
                

                setILUserPortfolioData(true)
                if (res.data.available == true) {
                    axios.get("https://api-ru.fynex.cc/api/api/user/portfolio/available", {headers: {"Authorization": `Bearer ${token}`}})
                        .then(res => {
                            setPortfoliosData(res.data.items)
                            setILPortfolioData(true)
                        })
                }
                if (res.data.active == true) {
                    axios.get("https://api-ru.fynex.cc/api/api/portfolio/upgrade", {headers: {"Authorization": `Bearer ${token}`}})
                        .then(res => {
                            setPortfoliosDataUpgrade(res.data)
                            setILPortfolioDataUP(true)
                        })
                }
            })
    }
    const [RPL, setRPL] = useState(false)
    const getUserPortfolioDataReserved = () => {
        axios.get("https://api-ru.fynex.cc/api/api/user/portfolio/reserved", {headers: {"Authorization": `Bearer ${token}`}})
            .then(res => {
                setUserPortfolioDataReserved(res.data)
                if (res.data === null) {
                    setRPL(false)
                }
                else{
                    setRPL(true)
                }
            })
    }

    const buyPorfolio = (id, reserved) => {
        axios.post("https://api-ru.fynex.cc/api/api/portfolio", {id, reserved}, {headers: {"Authorization": `Bearer ${token}`}})
            .then(res => {
                enqueueSnackbar(t("portfolio.sucefy"), {action, 'variant': 'success', 'className': "snacksuccess"});
                setTimeout(() => document.location.reload(), 700)
            })
            .catch( error => {
                enqueueSnackbar(`${t("portfolio.errMsg")}: ${error.response?.data?.detail[0].msg == "Недостаточно средств" ? t("convert.noMoney") : error.response?.data?.detail[0].msg}`, {action, 'variant': 'error', 'className': "snackerror"});
            });
    }
    const handleBuyRvd = (id, reserved) => {
        axios.post("https://api-ru.fynex.cc/api/api/portfolio", {id, reserved}, {headers: {"Authorization": `Bearer ${token}`}})
            .then(res => {
                enqueueSnackbar(t("portfolio.sucefy"), {action, 'variant': 'success', 'className': "snacksuccess"});
                setTimeout(() => document.location.reload(), 700)
            })
            .catch( error => {
                enqueueSnackbar(`${t("portfolio.errMsg")}: ${error.response?.data?.detail[0].msg == "Недостаточно средств" ? t("convert.noMoney") : error.response?.data?.detail[0].msg}`, {action, 'variant': 'error', 'className': "snackerror"});
            });
    }

    const upgradePorfolio = (upgrade_id, reserved) => {
        axios.post("https://api-ru.fynex.cc/api/api/portfolio/upgrade", {"id": upgrade_id, reserved}, {headers: {"Authorization": `Bearer ${token}`}})
            .then(res => {
                enqueueSnackbar(t("portfolio.sucefy"), {action, 'variant': 'success', 'className': "snacksuccess"});
                setTimeout(() => document.location.reload(), 700)
            })
            .catch( error => {
                enqueueSnackbar(`${t("portfolio.errMsg")}: ${error.response?.data?.detail[0].msg}`, {action, 'variant': 'error', 'className': "snackerror"});
            });
    }
    const reservePorfolio = (id) => {
        axios.post("https://api-ru.fynex.cc/api/api/portfolio/reserved", {id}, {headers: {"Authorization": `Bearer ${token}`}})
            .then(res => {
                enqueueSnackbar(t("portfolio.sucefy"), {action, 'variant': 'success', 'className': "snacksuccess"});
                setTimeout(() => document.location.reload(), 700)
            })
            .catch( error => {
                enqueueSnackbar(`${t("portfolio.errMsg")}: ${error.response?.data?.detail[0].msg}`, {action, 'variant': 'error', 'className': "snackerror"});
            });
    }

    useEffect(()=>{
        getUserPortfolioData()
        getUserPortfolioDataReserved()
    },[])
    useEffect(()=>{
        console.log(userPortfolioData, "userPortfolioData")
        console.log(userPortfolioDataReserved, "userPortfolioDataReserved")
        console.log(portfoliosData, "portfoliosData")
        console.log(portfoliosDataUpgrade, "portfoliosDataUpgrade")
        console.log(ILuserPortfolioData, "ILuserPortfolioData")
        console.log(ILPortfolioData, "ILPortfolioData")
        console.log(ILPortfolioDataUP, "ILPortfolioDataUP")
        console.log(RPL, "RPL")
    },[])


    const returnCase = (caseName) => {
        if(caseName == "bronze") return <Standart/>
        if(caseName == "silver") return <Business/>
        if(caseName == "gold") return <Corporate/>
    }
    const returnText = (caseName) => {
        if(caseName == "bronze") return t("portfolio.bronze")
        else if(caseName == "silver") return t("portfolio.silver")
        else if(caseName == "gold") return t("portfolio.gold")
        else caseName
    }
    const returnPriceInfo = (caseName) => {
        if(caseName == "bronze") return "5,000"
        if(caseName == "silver") return "10,000"
        if(caseName == "gold") return "25,000"
    }
    const returnDaysInfo = (startDay, endDay) => {
        const date1 = new Date(startDay)
        const date2 = new Date(endDay)
        const dateNow = new Date()
        const countGeneralDays = (date2 - date1) / (1000 * 60 * 60 * 24)    //  общее количество востребованных дней
        const differenceStart = Math.round( (dateNow - date1) / (1000 * 60 * 60 * 24) ) // время от старта то сейчас
        // если время end прошло то вовзращаеться countGeneralDays
        return `${differenceStart > countGeneralDays ? countGeneralDays : differenceStart} / ${countGeneralDays}`
    }
    const returnCountGeneralDays = (startDay, endDay) => {
        const date1 = new Date(startDay)
        const date2 = new Date(endDay)
        const countGeneralDays = (date2 - date1) / (1000 * 60 * 60 * 24)
        return countGeneralDays
    }
    const returnSubcategory = (subcategory) => {
        if(subcategory == "PRO") return <PRO/>
        if(subcategory == "ULTRA") return <ULTRA/>
        if(subcategory == "EXTRA") return <EXTRA/>
    }

    const Plate = ({category, subcategory, value, start, end, id, name}) => <div className='plate'>            
        {returnCase(category)}
        <div className="line"/>
        <div className="infoBlock">
            <h2>{name} {returnSubcategory(subcategory)}</h2>
            {/* <p>{t('portfolio.AnnualYield')} {category == "bronze" ? "547" : category == "silver" ? "1,093" : "2,431"}%</p> */}
            
            <p>{t('portfolio.depositAmount')} {value}$</p>
            {/* {type == "availablePlan" && <p>{t('portfolio.currentProfit')} {value}$</p>} */}
        </div>
        <div className="line"/>
        <div className="priceInfo">
            <h2>{value}$</h2>
            <p>{returnDaysInfo(start, end)} {t('portfolio.days')}</p>
        </div>
    </div>

    return (
        <div className='Portfolio'>
            <Header hasMenu2={true}/>
            <div className="PortfolioWrapper">
                <h2>{t('portfolio.investmentPortfolios')}</h2>
                {userPortfolioData?.available && userPortfolioData.reserved == false?
                    <div className="activePlans Plans">     {/* Ваш активный план */}
                        <div className='plateHeadline'>
                            {t('portfolio.yourActivePlan')}
                        </div>
                        {userPortfolioData.category != undefined ? <div className='activePlansWrapper activePlanWrapper'>
                            <Plate category={userPortfolioData.category} subcategory={userPortfolioData.subcategory} value={userPortfolioData.value} start={userPortfolioData.start} end={userPortfolioData.end} name={userPortfolioData.name}  />          
                                 <div className="plateDescription">
                                    <p>{t('portfolio.depositAmount')}{userPortfolioData.value}</p>
                                    <br />
                                    <p>{userPortfolioData.description}</p>
                                </div>
                        </div> 
                        :
                        ""}
                    </div>
                    :
                    <>
                        {/* navigate("/portfolio-error") */}
                    </>
                }
                {console.log(userPortfolioDataReserved, "userPortfolioDataReserved!!!s")}
                
                {RPL ?
                    userPortfolioDataReserved.length != 0 && userPortfolioDataReserved[0].reserved == true && userPortfolioDataReserved[0].reserved == true && userPortfolioDataReserved[0].available == true && <>
                    <div className='plateHeadline'>
                        {t('portfolio.reserved')}
                    </div>
                    <div className="activePlansWrapper">
                        {userPortfolioDataReserved.map(data=> <div className='plateWrapper'>
                            <Plate category={data.category} subcategory={data.subcategory} value={data.value} start={data.start} end={data.end} id={data.id} name={data.name} />          
                            <div className="plateDescription">
                                <p>{data.description}</p>
                                <Button text={t("portfolio.activityButton")} onClick={()=>{handleBuyRvd(data.id, data.reserved)}} />
                            </div>
                        </div> )}
                    </div>
                    </>
                    :
                    <div className="availablePlans Plans">
                        {
                            ILPortfolioDataUP && <>
                            <div className='plateHeadline'>
                                {t('portfolio.upgradePlan')}
                            </div>
                            <div className="activePlansWrapper">
                                {portfoliosDataUpgrade.map(data=> <div className='plateWrapper'>
                                    <Plate category={data.category} subcategory={data.subcategory} value={data.value} start={data.start} end={data.end} id={data.id} name={data.name} />          
                                    <div className="plateDescription">
                                        <p>{data.description}</p>
                                        <Button text={t("portfolio.upgradePlan")} onClick={()=>{buyPorfolio(data.id, data.reserved)}} />
                                    </div>
                                </div> )}
                            </div>
                            </>
                        }
                        {
                            userPortfolioData.available && userPortfolioData.active == false ? <>
                                <div className='plateHeadline'>
                                    {t('portfolio.availablePlans')}
                                </div>
                                <div className="activePlansWrapper">
                                    {portfoliosData.map(data=> <div className='plateWrapper'>
                                        <Plate category={data.category} subcategory={data.subcategory} value={data.value} start={data.start} end={data.end} id={data.id} name={data.name} />          
                                        <div className="plateDescription">
                                            <p>{data.description}</p>
                                            <Button text={t("portfolio.activate")} onClick={()=>{buyPorfolio(data.id, data.reserved)}} />
                                            <Button text={t("portfolio.reservBtn")} onClick={() => reservePorfolio(data.id)} />
                                        </div>
                                    </div> )}
                                </div>

                            </> : ""
                        }
                    </div>
                }
                {/* {userPortfolioData.available ? (
                    <div className="availablePlans Plans">
                        <div className='plateHeadline'>
                            {t('portfolio.availablePlans')}
                        </div>
                        <ul className='Upgrade'>
                            {userPortfolioData.active !== true && portfoliosData?.map((item, idx) => item.available && !item.active && (
                                <li key={idx}>
                                    <div className="liData" onClick={(e) => {
                                        e.currentTarget.parentElement.className.includes("liDataActive")
                                            ? e.currentTarget.parentElement.classList.remove("liDataActive")
                                            : e.currentTarget.parentElement.classList.add("liDataActive");
                                    }}>
                                        {returnCase(item.category)}
                                        <div className="line"/>
                                        <div className="infoBlock">
                                            {console.log(item, "ITME")}
                                            <h2>{returnText(item.category)}</h2>
                                            <p>{t('portfolio.currentProfit')}: {item.value}$</p>
                                        </div>
                                        <div className="line"/>
                                        <div className="priceInfo">
                                            <h2>{returnPriceInfo(item.category)}$</h2>
                                            <p>{returnCountGeneralDays(item.start, item.end)} {t('portfolio.days')}</p>
                                        </div>
                                    </div>
                                    <div className="infoBlockUpgrades">
                                        <p>{item.description}</p>
                                        <div className="buttons">
                                            {item.upgrade && <Button text={t('portfolio.upgradePlan')} onClick={() => upgradePorfolio(item.id, item.reserved)}/>}
                                            {!item.reserved && <Button text={t('portfolio.reserve')} onClick={() => reservePorfolio(item.id, item.reserved)}/>}
                                            {item.available && <Button text={t('portfolio.buy')} onClick={() => buyPorfolio(item.id, item.reserved)}/>}
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <>
                        <div className="unavailable">{t('portfolio.noAccess')}{navigate("/portfolio-error")}</div>
                    </>

                )} */}
            </div>
        </div>
    )
}

export default Portfolio



// import React, {useEffect, useState} from 'react'
// import Header from '../../../components/header/Header'
// import { ReactComponent as Standart } from '../../../assets/icons/portfolio/StandartBriefcase.svg'
// import { ReactComponent as Business } from '../../../assets/icons/portfolio/businessBriefcase.svg'
// import { ReactComponent as Corporate } from '../../../assets/icons/portfolio/CorporateBriefcase.svg'
// import { ReactComponent as CloseIcon } from "../../../assets/icons/portfolio/login-cross.svg";
// import { ReactComponent as PRO} from "../../../assets/icons/portfolio/PRO.svg";
// import { ReactComponent as ULTRA} from "../../../assets/icons/portfolio/ULTRA.svg";
// import { ReactComponent as EXTRA} from "../../../assets/icons/portfolio/EXTRA.svg";
// import Button from '../../../components/button/Button'
// import axios from 'axios'
// import {closeSnackbar, enqueueSnackbar} from "notistack";
// import './Portfolio.css'
// import {useTranslation} from "react-i18next";
// import { useNavigate } from 'react-router-dom'

// const Portfolio = () => {

//     const {t} = useTranslation();
//     const navigate = useNavigate()
//     const action = snackbarId => (
//         <button onClick={() => { closeSnackbar(snackbarId) }}>
//             <CloseIcon/>
//             {/* CLOSEICON */}
//         </button>
//     );

//     const [userPortfolioData, setUserPortfolioData] = useState({active: false})
//     const [userPortfolioDataReserved, setUserPortfolioDataReserved] = useState([])
//     const [portfoliosData, setPortfoliosData] = useState([])
//     const [portfoliosDataUpgrade, setPortfoliosDataUpgrade] = useState([])
//     const [ILuserPortfolioData, setILUserPortfolioData] = useState(false)
//     const [ILPortfolioData, setILPortfolioData] = useState(false)
//     const [ILPortfolioDataUP, setILPortfolioDataUP] = useState(false)

//     const [switcher, setSwitch] = useState(0)
//     const [switcher2, setSwitch2] = useState(0)


//     // const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImtvcmtvdmRpbWEyNjNAZ21haWwuY29tIiwicGhvbmVfbnVtYmVyIjoiKzM4MDM0MjM0MjM0MjM0MjMiLCJ1c2VybmFtZSI6ImtvcmtvdmRpbWEyNjMiLCJjb3VudHJ5IjoiQmVybGlubm4iLCJjaXR5IjoiT3BvbCIsIm5hbWUiOiJcdTA0MTBcdTA0M2JcdTA0MzhcdTA0M2RcdTA0MzAiLCJzdXJuYW1lIjoiXHUwNDFhXHUwNDNlXHUwNDQwXHUwNDNhXHUwNDNlXHUwNDMyXHUwNDMwIiwiZGlzcGxheWVkX25hbWUiOiJcdTA0MTBcdTA0MWRcdTA0MWRcdTA0MTAiLCJzdGF0ZSI6ZmFsc2UsImNvbW1lbnQiOiIuIiwiaWQiOjIwNjIsImF2YXRhcl9saW5rIjoic3RhdGljZmlsZXMvYXZhdGFycy9rb3Jrb3ZkaW1hMjYzLmpwZyIsInBvcnRmb2xpb19hdmFpbGFibGUiOnRydWUsIndpdGhkcmF3X2FsbG93ZWQiOnRydWUsIm9yZGVyc19hbGxvd2VkIjp0cnVlLCJzaGFyZXNfYWxsb3dlZCI6dHJ1ZSwic3BvdF9zaGFyZXNfYWxsb3dlZCI6dHJ1ZSwic3RhdHVzIjoiIn0.pPAekI-3xF791TOKX7vwqpTNmDLQcx6i17aXy40qbI4";
//     const token = localStorage.getItem("token")


//     const getUserPortfolioData = () => {
//         axios.get("https://api-ru.fynex.cc/api/api/user/portfolio", {headers: {"Authorization": `Bearer ${token}`}})
//             .then(res => {
//                 setUserPortfolioData(res.data)

//                 setILUserPortfolioData(true)
//                 if (res.data.available == true) {
//                     axios.get("https://api-ru.fynex.cc/api/api/user/portfolio/available", {headers: {"Authorization": `Bearer ${token}`}})
//                         .then(res => {
//                             setPortfoliosData(res.data.items)
//                             setILPortfolioData(true)
//                         })
//                 }
//                 if (res.data.active == true) {
//                     axios.get("https://api-ru.fynex.cc/api/api/portfolio/upgrade", {headers: {"Authorization": `Bearer ${token}`}})
//                         .then(res => {
//                             setPortfoliosDataUpgrade(res.data)
//                             setILPortfolioDataUP(true)
//                         })
//                 }
//             })
//     }
//     const [RPL, setRPL] = useState(false)
//     const getUserPortfolioDataReserved = () => {
//         axios.get("https://api-ru.fynex.cc/api/api/user/portfolio/reserved", {headers: {"Authorization": `Bearer ${token}`}})
//             .then(res => {
//                 setUserPortfolioDataReserved(res.data)
//                 if (res.data === null) {
//                     setRPL(false)
//                 }
//                 else{
//                     setRPL(true)
//                 }
//             })
//     }

//     const buyPorfolio = (id, reserved) => {
//         axios.post("https://api-ru.fynex.cc/api/api/portfolio", {id, reserved}, {headers: {"Authorization": `Bearer ${token}`}})
//             .then(res => {
//                 enqueueSnackbar(t("portfolio.sucefy"), {action, 'variant': 'success', 'className': "snacksuccess"});
//                 setTimeout(() => document.location.reload(), 700)
//             })
//             .catch( error => {
//                 enqueueSnackbar(`${t("portfolio.errMsg")}: ${error.response?.data?.detail[0].msg}`, {action, 'variant': 'error', 'className': "snackerror"});
//             });
//     }
//     const handleBuyRvd = (id, reserved) => {
//         axios.post("https://api-ru.fynex.cc/api/api/portfolio", {id, reserved}, {headers: {"Authorization": `Bearer ${token}`}})
//             .then(res => {
//                 enqueueSnackbar(t("portfolio.sucefy"), {action, 'variant': 'success', 'className': "snacksuccess"});
//                 setTimeout(() => document.location.reload(), 700)
//             })
//             .catch( error => {
//                 enqueueSnackbar(`${t("portfolio.errMsg")}: ${error.response?.data?.detail[0].msg}`, {action, 'variant': 'error', 'className': "snackerror"});
//             });
//     }

//     const upgradePorfolio = (upgrade_id, reserved) => {
//         axios.post("https://api-ru.fynex.cc/api/api/portfolio/upgrade", {"id": upgrade_id, reserved}, {headers: {"Authorization": `Bearer ${token}`}})
//             .then(res => {
//                 enqueueSnackbar(t("portfolio.sucefy"), {action, 'variant': 'success', 'className': "snacksuccess"});
//                 setTimeout(() => document.location.reload(), 700)
//             })
//             .catch( error => {
//                 enqueueSnackbar(`${t("portfolio.errMsg")}: ${error.response?.data?.detail[0].msg}`, {action, 'variant': 'error', 'className': "snackerror"});
//             });
//     }
//     const reservePorfolio = (id) => {
//         axios.post("https://api-ru.fynex.cc/api/api/portfolio/reserved", {id}, {headers: {"Authorization": `Bearer ${token}`}})
//             .then(res => {
//                 enqueueSnackbar(t("portfolio.sucefy"), {action, 'variant': 'success', 'className': "snacksuccess"});
//                 setTimeout(() => document.location.reload(), 700)
//             })
//             .catch( error => {
//                 enqueueSnackbar(`${t("portfolio.errMsg")}: ${error.response?.data?.detail[0].msg}`, {action, 'variant': 'error', 'className': "snackerror"});
//             });
//     }

//     useEffect(()=>{
//         getUserPortfolioData()
//         getUserPortfolioDataReserved()
//     },[])



//     const returnCase = (caseName) => {
//         if(caseName == "bronze") return <Standart/>
//         if(caseName == "silver") return <Business/>
//         if(caseName == "gold") return <Corporate/>
//     }
//     const returnText = (caseName) => {
//         if(caseName == "bronze") return t("portfolio.bronze")
//         if(caseName == "silver") return t("portfolio.silver")
//         if(caseName == "gold") return t("portfolio.gold")
//     }
//     const returnPriceInfo = (caseName) => {
//         if(caseName == "bronze") return "5,000"
//         if(caseName == "silver") return "10,000"
//         if(caseName == "gold") return "25,000"
//     }
//     const returnDaysInfo = (startDay, endDay) => {
//         const date1 = new Date(startDay)
//         const date2 = new Date(endDay)
//         const dateNow = new Date()
//         const countGeneralDays = (date2 - date1) / (1000 * 60 * 60 * 24)    //  общее количество востребованных дней
//         const differenceStart = Math.round( (dateNow - date1) / (1000 * 60 * 60 * 24) ) // время от старта то сейчас
//         // если время end прошло то вовзращаеться countGeneralDays
//         return `${differenceStart > countGeneralDays ? countGeneralDays : differenceStart} / ${countGeneralDays}`
//     }
//     const returnCountGeneralDays = (startDay, endDay) => {
//         const date1 = new Date(startDay)
//         const date2 = new Date(endDay)
//         const countGeneralDays = (date2 - date1) / (1000 * 60 * 60 * 24)
//         return countGeneralDays
//     }
//     const returnSubcategory = (subcategory) => {
//         if(subcategory == "PRO") return <PRO/>
//         if(subcategory == "ULTRA") return <ULTRA/>
//         if(subcategory == "EXTRA") return <EXTRA/>
//     }

//     const MyActivePlan = () => <div className="plate">
//                     <div className="activePlans Plans">
//                         {console.log(userPortfolioData, "asd")}
                        
//                         {userPortfolioData &&
//                             <ul className='Plan'>
//                                 <li>
//                                     {returnCase(userPortfolioData.category)}
//                                     <div className="line"/>
//                                     <div className="infoBlock">
//                                         {console.log(returnSubcategory(userPortfolioData.subcategory))}
//                                         <h2>{returnText(userPortfolioData.category)} {returnSubcategory(userPortfolioData.subcategory)}</h2>
//                                         <p>{t('portfolio.currentProfit')} {userPortfolioData.value}$</p>
//                                     </div>
//                                     <div className="line"/>
//                                     <div className="priceInfo">
//                                         <h2>{returnPriceInfo(userPortfolioData.category)}$</h2>
//                                         <p>{returnDaysInfo(userPortfolioData.start, userPortfolioData.end)} {t('portfolio.days')}</p>
//                                     </div>
//                                 </li>
//                             </ul>
//                         }
//                     </div>
//     </div>


//     return (
//         // <div className='Portfolio'>
//         //     <Header hasMenu2={true}/>
//         //     <div className="PortfolioWrapper">
//         //         <h2>{t('portfolio.investmentPortfolios')}</h2>
//         //         {userPortfolioData?.active &&<>
//         //             <div className="plateHeadline">{t("portfolio.yourActivePlan")}</div>
//         //             <div className="blocActivePlan">
//         //                 <MyActivePlan />
//         //                 <div className="dataPlan">
//         //                     <ul>
//         //                         <li>{t("portfolio.currentProfit")} <span className='plus'>{"123$"}</span> </li>
//         //                         <li>{t("portfolio.activen") +  ": " + "10 " +  t("portfolio.days")  }</li>
//         //                     </ul>

//         //                     <ul>{t("portfolio.distributionActive")}</ul>

//         //                     <ul>
//         //                         <li><span className='currency'>AAPL</span> 25%</li>
//         //                         <li><span className='currency'>MSFT</span> 25%</li>
//         //                     </ul>
//         //                     <ul>
//         //                         <li><span className='currency'>AMZN</span> 25%</li>
//         //                         <li><span className='currency'>KO</span> 25%</li>
//         //                     </ul>
//         //                     <ul>
//         //                         <li><span className='currency'>JNJ</span> 25%</li>
//         //                         <li><span className='currency'>BRK.B</span> 25%</li>
//         //                     </ul>
//         //                 </div>
//         //             </div>
//         //         </>}
//         //     </div>
//         // </div>



//         <div className='Portfolio'>
//             <Header hasMenu2={true}/>
//             <div className="PortfolioWrapper">
//                 <h2>{t('portfolio.investmentPortfolios')}</h2>
//                 {userPortfolioData?.active &&
//                     <div className="activePlans Plans">
//                         <div className='tableName'>
//                             <p>{t('portfolio.yourActivePlan')}</p>
//                         </div>
//                         {console.log(userPortfolioData, "userPortfolioData")}
//                         {userPortfolioData &&
//                             <ul className='Plan'>
//                                 <li>
//                                     {returnCase(userPortfolioData.category)}
//                                     <div className="line"/>
//                                     <div className="infoBlock">
//                                         <h2>{`${returnText(userPortfolioData.category)} ${returnSubcategory(userPortfolioData.subcategory)}`}</h2>
//                                         <p>{t('portfolio.currentProfit')}: {userPortfolioData.value}$</p>
//                                     </div>
//                                     <div className="line"/>
//                                     <div className="priceInfo">
//                                         <h2>{returnPriceInfo(userPortfolioData.category)}$</h2>
//                                         <p>{returnDaysInfo(userPortfolioData.start, userPortfolioData.end)} {t('portfolio.days')}</p>
//                                     </div>
//                                 </li>
//                             </ul>
//                         }
//                     </div>
//                 }
//                 {userPortfolioData.available ? (
//                     <div className="availablePlans Plans">
//                         <div className='tableName'>
//                             <p>{t('portfolio.availablePlans')}</p>
//                         </div>
//                         <ul className='Upgrade'>
//                             {userPortfolioData.active !== true && portfoliosData?.map((item, idx) => item.available && !item.active && (
//                                 <li key={idx}>
//                                     <div className="liData" onClick={(e) => {
//                                         e.currentTarget.parentElement.className.includes("liDataActive")
//                                             ? e.currentTarget.parentElement.classList.remove("liDataActive")
//                                             : e.currentTarget.parentElement.classList.add("liDataActive");
//                                     }}>
//                                         {returnCase(item.category)}
//                                         <div className="line"/>
//                                         <div className="infoBlock">
//                                             {console.log(item, "ITME")}
//                                             <h2>{returnText(item.category)}</h2>
//                                             <p>{t('portfolio.currentProfit')}: {item.value}$</p>
//                                         </div>
//                                         <div className="line"/>
//                                         <div className="priceInfo">
//                                             <h2>{returnPriceInfo(item.category)}$</h2>
//                                             <p>{returnCountGeneralDays(item.start, item.end)} {t('portfolio.days')}</p>
//                                         </div>
//                                     </div>
//                                     <div className="infoBlockUpgrades">
//                                         <p>{item.description}</p>
//                                         <div className="buttons">
//                                             {item.upgrade && <Button text={t('portfolio.upgradePlan')}
//                                                                      onClick={() => upgradePorfolio(item.id, item.reserved)}/>}
//                                             {!item.reserved && <Button text={t('portfolio.reserve')}
//                                                                        onClick={() => reservePorfolio(item.id, item.reserved)}/>}
//                                             {item.available && <Button text={t('portfolio.buy')}
//                                                                        onClick={() => buyPorfolio(item.id, item.reserved)}/>}
//                                         </div>
//                                     </div>
//                                 </li>
//                             ))}
//                         </ul>
//                     </div>
//                 ) : (
//                     <>
//                         <div className="unavailable">{t('portfolio.noAccess')}{navigate("/portfolio-error")}</div>
//                     </>

//                 )}
//             </div>
//         </div>
//     )
// }

// export default Portfolio